import {useVerifiedPermissions} from '@flexinet/auth-components';

// Interim until FNP-1749. When the permissions check itself fails,
// `allowedActions` is empty and the gated layouts would redirect away as if
// the user had no permissions. Throw instead, so the route's existing
// errorElement (ApplicationErrorPage) says the check failed.
export const usePermissionsFailureGuard = () => {
    const {status} = useVerifiedPermissions()
    if (status === 'failed') {
        throw new Error("We couldn't check your permissions.")
    }
}
